export default __webpack_public_path__ + "static/media/energy-dark.fe382aca.svg";